import React from "react";

export default function SurveyCardContent({
    headerText,
    questionText,
    description,
    backButton,
    nextButton,
    questionCounter
  }) {
  return (
    <>
      <h3>{headerText}</h3>

      <div className="survey-question">{questionText}</div>
      {description}

      <div className="button-container">
        {backButton}

        <div className="next-button-container">
          {questionCounter && <span>{questionCounter}</span>}
          {nextButton}
        </div>
      </div>
    </>
  );
}
